import React from 'react'
import { useParams } from 'react-router'
import { useArea } from '../../hooks/CompanyConfiguration/useArea'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import AreaView from '../../components/version-4/viewForms/AreaView'
import { ROUTES } from '../../shared/constants'

function ViewArea() {
  const { area, getArea } = useArea()
  const params = useParams()

  React.useEffect(() => {
    getArea({ areaId: params.areaId })
  }, [params.areaId])

  return (
    <Layout heading="Area" heading2="Info" url1={ROUTES.AREA} none>
      {area ? (
        <HeaderTabLayout heading="Area" content={<AreaView area={area} />} view url={`/edit-area/${params.areaId}`} />
      ) : (
        <Loader />
      )}
    </Layout>
  )
}

export default ViewArea
